import { render } from "./CoursesCouponTab.vue?vue&type=template&id=4ae0350d"
import script from "./CoursesCouponTab.vue?vue&type=script&lang=js"
export * from "./CoursesCouponTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__